<template>
<div class="login-container" v-if="loaded">
  <div class="login-inputs login-form" style="margin-top:13em;">
    <form v-if="!reset_code && !is_forgot_password" @submit.prevent="login">
    <div class="m-b-30 header">{{$t(greetingMessage())}}<br>{{$t('welcome')}}</div>
      <div>
        <InputText
          class="login-input"
          placeholder="Email"
          label="Email"
          v-model="email"
        />
      </div>
      <div>
        <InputText
          class="login-input"
          placeholder="Password"
          type="password"
          :label="$t('password')"
          v-model="password"
          :link="`${$t('forgot_password')}`"
          @linkAction="is_forgot_password = !is_forgot_password"
          v-on:keyup.enter.native="login"
        />
      </div>
      <div class="login-buttons">
      <Btn
        class="brand login-button"
        :btnText="$t('sign_in')"
        @btnClick="login"/>
      </div>
    </form>
    <form v-else-if="!reset_code && is_forgot_password" @submit.prevent="forgotPassword">
     <div class="m-b-30 header">{{$t('reset_your_password_here')}}</div>
      <div>
        <InputText
          class="login-input"
          placeholder="Email"
          label="Email"
          v-model="forgot_password_email"
        />
      </div>
      <div class="login-buttons">
        <Btn
          class="brand login-button"
          :btnText="$t('Reset password')"
          @btnClick="forgotPassword"/>
      </div>
      <a  href="#" @click="is_forgot_password = !is_forgot_password">
      {{$t('back_to_login')}}
      </a>
    </form>
    <form v-else-if="reset_code" class="login small-width" @submit.prevent="resetPassword">
      <div>
        <InputText
          class="login-input"
          type="password"
          :label="$t('enter_new_password')"
          v-model="reset_password"
          :rules="{required: true}"
        />
        <InputText
          class="login-input"
          type="password"
          :label="$t('confirm_your_password')"
          v-model="reset_password_confirmation"
          :rules="{required: true}"
        />
        <template v-if="is_new_user">
        <hr style="margin: 20px 0; border: 0.5px solid #eee;">
        <InputText
          class="login-input"
          :label="$t('first_name')"
          v-model="first_name"
          :rules="{required: true}"
        />
        <InputText
          class="login-input"
          :label="$t('last_name')"
          v-model="last_name"
          :rules="{required: true}"
        />
        <InputText
          class="login-input"
          :label="$t('function')"
          v-model="user_function"
        />
        <PhoneSelect class="login-input" key="loginPhone" v-model="phone" />
        </template>
      </div>
      <Btn
        class="brand d-inline-block m-r-20"
        :icon="{
          name: 'check',
          size: '22',
          color: '#fff',
        }"
        :btnText="$t('Reset password')"
        @btnClick="resetPassword"/>
      <a href="#" @click="reset_code = ''">{{$t('back_to_login')}}</a>
    </form>
  </div>
  <div class="login-image-container">
    <img v-if="computeHeroImage" class="img" :src="computeHeroImage" alt="login">
    <img v-else class="img" src="../assets/images/login-background.png" alt="login">
  </div>
</div>
</template>
<script>
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import { mapGetters } from 'vuex';
import axios from 'axios'
/* eslint-disable */
export default {
  name: 'Login',
  components: {Btn, InputText, PhoneSelect},
  data() {
    return {
      loaded: false,
      is_forgot_password: false,
      email: process.env.VUE_APP_EMAIL,
      password: process.env.VUE_APP_PASSWORD,
      redirectRoute: this.$route.query.from || process.env.VUE_APP_DEFAULT_PAGE,
      forgot_password_email: '',
      reset_code: '',
      is_new_user: false,
      reset_password: '',
      reset_password_confirmation: '',
      first_name: '',
      last_name: '',
      user_function: '',
      phone: {
        number: '',
        country: '',
      },
      loginSettings: {}
    };
  },
  computed: {
    ...mapGetters([
      'get_admin_settings'
    ]),
    computeHeroImage() {
      if (this.loginSettings.admin_login_image) {
        return this.loginSettings.admin_login_image
      }
      return false;
    }
  },
  created() {
    this.reset_code = this.$route.query.code || new URLSearchParams(window.location.search).get('code');
    if (this.reset_code) {
      // Determine if this is a new user from the URL parameter (set by backend when generating the link)
      this.is_new_user = this.$route.query.new === '1' || new URLSearchParams(window.location.search).get('new') === '1';
      // Prefetch user data by code to pre-fill the form fields
      axios.get('/authenticate/user-by-code', { params: { code: this.reset_code } })
        .then(res => {
          const u = res.data?.data || {}
          this.first_name    = u.first_name || ''
          this.last_name     = u.last_name || ''
          this.user_function = u.function || ''
          if (u.phone) {
            this.phone = { number: u.phone, country: u.phone_country || '' }
          }
        })
        .catch(() => {})
    }
    this.$store.dispatch('GET_ADMIN_SETTINGS', window.location.hostname).then((r) => {
      this.loginSettings = this.get_admin_settings

      if(this.loginSettings.admin_custom_style) {
        const head = document.head || document.getElementsByTagName('head')[0]
        const style = document.createElement('style')

        head.appendChild(style);
        style.appendChild(document.createTextNode(this.loginSettings.admin_custom_style));
      }
    }).finally(() => setTimeout( () => this.loaded = true, 50));
  },
  methods: {
    login() {
      if (this.email === '' && this.password === '') {
        return;
      } else {
        this.$store.dispatch('LOGIN', {
          email: this.email,
          password: this.password
        }).then((loginRes) => {
          // STORE TOKEN
          this.$store.dispatch('STORE_TOKEN', loginRes.token).then(() => {
          // GET AND SOTRE USER
            this.$store.dispatch('GET_PROFILE').then((profileRes) => {
              this.$store.dispatch('STORE_USER', profileRes);
              this.$store.dispatch('GET_MY_PERMISSIONS').then(() => {
                this.$store.dispatch('GET_SUBACCOUNTS').then((response) => {
                  if (!response.length) {
                    alert('There is no available accounts. Please contact support')
                  }
                  if(profileRes.active_subaccount_id != null){
                    this.$store.dispatch('STORE_ACTIVE_SUBACCOUNT', response.filter((item) => item.id == profileRes.active_subaccount_id)[0]);
                    localStorage.setItem('subaccount',  JSON.stringify(response.filter((item) => item.id == profileRes.active_subaccount_id)[0]));
                  } else {
                    this.$store.dispatch('STORE_ACTIVE_SUBACCOUNT', response.filter((item) => item.is_main == 1 )[0]);
                    localStorage.setItem('subaccount',  JSON.stringify(response.filter((item) => item.is_main == 1 )[0]));
                  }
                  localStorage.userId = profileRes.id
                  this.$store.dispatch('LOGIN_USER_FLAG', true);
                  this.$router.push(this.redirectRoute);
                })
              });
            });
          });
        });
      }
    },
    checkPermission(permissions) {
      let result = false;
      this.get_user_permissions.forEach((perm) => {
        if(perm.acl_route_group == permission) result = perm.view;
      })
      return result;
    },
    forgotPassword() {
      this.$store.dispatch('FORGOT_PASSWORD', {email: this.forgot_password_email})
        .then(() => {
          this.$store.commit('SHOW_NOTIFICATION_BAR', {
            message: this.$t('check_your_email'),
            type: 'success-window',
            iconName: 'check',
          });
          this.is_forgot_password = false;
        });
    },
    resetPassword() {
      this.$store.dispatch('RESET_PASSWORD', {
        code: this.reset_code,
        password: this.reset_password,
        confirm_password: this.reset_password_confirmation,
        first_name: this.first_name,
        last_name: this.last_name,
        function: this.user_function,
        phone: this.phone.number,
      }).then(() => {
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: this.$t('Reset password'),
          type: 'success-window',
          iconName: 'check',
        });
        this.reset_code = '';
        this.$router.replace('/login');
      }).catch(() => {});
    },
    greetingMessage(){
      const today = new Date();
      const h = today.getHours();
      if (h>=5 && h<12){
        return 'good_morning';
      }else if (h>=12 && h<17 ){
        return 'good_afternoon';
      }else {
        return 'good_evening';
      }
    },
  }
};
</script>
